var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('small',[_vm._v(_vm._s(this.$i18n.LATEST_DATA_IMPORT)+" "+_vm._s(_vm.dbUpdateTime))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }